import axios from 'axios';
import moment from "moment";

export default {
    fetchLineViewData: (filter, success, error) => {
        axios.get('lineview', {
            params: {
                station_id: filter.stationId,
                shift_id: filter.stationShiftId,
                date: filter.date
            }
        })
            .then(r => success(r.data))
            .catch(e => console.log(e))
    },
    fetchLineOeeChartData: (filter, success, error) => {
        axios.get('lineviewChartData', {
            params: {
                station_id: filter.stationId,
                shift_id: filter.stationShiftId,
                date: filter.date
            }
        })
            .then(r => success(r.data))
            .catch(e => console.log(e))
    },
    fetchStationShift: (filter, success, error) => {
        axios.get('lineviewStationShift', {
            params: {
                station_id: filter.stationId
            }
        })
            .then(r => success(r.data))
            .catch(e => console.log(e))
    },
    fetchTopDowntimeReasons: (filter, success, error) => {
        axios.get('topDowntimeReasons', {
            params: {
                end: filter.end,
                start: filter.start,
                station_id: filter.stationId,
            }
        })
            .then(r => success(r.data))
            .catch(e => console.log(e))
    },
    fetchTopOperatorDowntimes: (filter, success, error) => {
        axios.get('topOperatorDowntimes', {
            params: {
                end: filter.end,
                start: filter.start,
                station_id: filter.stationId,
                station_shift_id: filter.stationShiftId,
            }
        })
            .then(r => success(r.data))
            .catch(e => console.log(e))
    },
    fetchOperatorName: (filter, success, error) => {
        axios.get('getOperatorName', {
            params: {
                stationId: filter.stationId,
                date: filter.date
            }
        })
            .then(r => success(r.data))
            .catch(e => console.log(e))
    },
    fetchTeamName: (filter, success, error) => {
        axios.get('getTeamName', {
            params: {
                stationId: filter.stationId,
                date: filter.date
            }
        })
            .then(r => success(r.data))
            .catch(e => console.log(e))
    },
    storeDefects: (data, success, error) => {
        axios.post('storeLineviewDefects',data)
            .then( r=> success(r.data))
            .catch(e => {
                error(e);
        });
    }
}
